import { Navigate, useOutletContext, useParams } from "react-router-dom";
import ClinicTabPanel from "./ClinicTabPanel";
import ProfileTabPanel from "./ProfileTabPanel";
import SubscriptionTabPanel from "./SubscriptionTabPanel";
import StorageTabPanel from "./StorageTabPanel";
import SmsTabPanel from "./SmsTabPanel";
import PaymentReportTabPanel from "./PaymentReportTabPanel";
import TreatmentReportTabPanel from "./TreatmentReportTabPanel";
import {
  DEFAULT_ACCOUNT_TAB,
  getAccountTabPath,
  isAccountTab,
} from "./accountConfig";
import type { MyAccountOutletContext } from "./myAccountOutletContext";

export default function MyAccountTabOutlet() {
  const { tab } = useParams<{ tab: string }>();
  const context = useOutletContext<MyAccountOutletContext>();

  if (!isAccountTab(tab)) {
    return <Navigate to={getAccountTabPath(DEFAULT_ACCOUNT_TAB)} replace />;
  }

  switch (tab) {
    case "clinic":
      return (
        <ClinicTabPanel
          clinic={context.clinic}
          clinicNameFallback={context.clinicNameToken}
          addressFallback={context.userAddress}
          phoneFallback={context.clinicPhone}
          logoUrl={context.logoUrl}
        />
      );
    case "profile":
      return (
        <ProfileTabPanel
          employee={context.employee}
          loading={context.userLoading}
          fallbackName={context.userName}
          fallbackRole={context.userRole}
        />
      );
    case "subscription":
      return (
        <SubscriptionTabPanel
          payment={context.payment}
          onManagePayment={() => context.navigate("/client/pay")}
        />
      );
    case "storage":
      return (
        <StorageTabPanel
          storage={context.storage}
          storageLoading={context.storageLoading}
          storageError={context.storageError}
          onRefresh={context.loadStorage}
        />
      );
    case "sms":
      return (
        <SmsTabPanel
          balance={context.smsBalance}
          usage={context.smsUsage}
          smsLoading={context.smsLoading}
          smsError={context.smsError}
          onRefresh={context.loadSms}
        />
      );
    case "reports":
      return <PaymentReportTabPanel />;
    case "treatment-reports":
      return <TreatmentReportTabPanel />;
    default:
      return null;
  }
}
